import {NavItem} from "../../../graphql";

export const codeCatalogNavItem:NavItem = {
    id: "codeCatalog",
    title: "Code Catalogue",
    isPreview: false,
    url: "/codes?default=true",
    children: [],
}
